<div
  [hidden]="loading"
  id="pcoded"
  class="pcoded"
  [attr.nav-type]="navType"
  [attr.theme-layout]="themeLayout"
  [attr.horizontal-placement]="verticalPlacement"
  [attr.horizontal-layout]="verticalLayout"
  [attr.pcoded-device-type]="pcodedDeviceType"
  [attr.vertical-effect]="verticalEffect"
  [attr.vnavigation-view]="vnavigationView"
  [attr.fream-type]="freamType"
  [attr.sidebar-img]="sidebarImg"
  [attr.sidebar-img-type]="sidebarImgType"
  [attr.layout-type]="layoutType"
  (window:resize)="onResize($event)"
>
  <!-- [attr.vertical-nav-type]="verticalNavType" -->
  <div class="pcoded-overlay-box"></div>
  <div class="pcoded-container navbar-wrapper">
    <nav
      class="navbar header-navbar pcoded-header"
      [attr.header-theme]="headerTheme"
      [attr.pcoded-header-position]="pcodedHeaderPosition"
    >
      <div class="navbar-wrapper">
        <div class="navbar-logo">
          <a
            class="mobile-menu"
            id="mobile-collapse"
            href="javascript:"
            (click)="toggleOpened()"
            [exclude]="'#main_navbar'"
            (clickOutside)="onClickedOutsideSidebar($event)"
          >
            <i class="ti-menu"></i>
          </a>
          <a [routerLink]="['/home']">
            <h2>uMuzi</h2>
          </a>
          <a
            href="javascript:"
            class="mobile-options"
            (click)="toggleHeaderNavRight()"
          >
            <i class="ti-more"></i>
          </a>
        </div>
        <div class="navbar-container container-fluid">
          <ul class="nav-left">
            <li>
              <div class="sidebar_toggle">
                <a href="javascript:"><i class="ti-menu"></i></a>
              </div>
            </li>
          </ul>

          <!-- Show this for logged in users -->
          <ul
            [@mobileHeaderNavRight]="navRight"
            [ngClass]="navRight"
            class="nav-right"
            *showAuthed="true"
          >
            <!-- Invites notifications start -->
            <li style="margin-top: 5px">
              <invite-alert-button
                [limit]="2"
                [config]="inviteConfig"
                [currentUser]="currentUser"
              >
              </invite-alert-button>
            </li>
            <!-- Invites notifications end  -->

            <!-- General notifications start -->
            <li style="margin-top: 5px">
              <notification-alert-button
                [limit]="2"
                [config]="notificationConfig"
                [currentUser]="currentUser"
              >
              </notification-alert-button>
            </li>
            <!-- General notifications end  -->

            <li
              *ngIf="currentUser"
              (clickOutside)="notificationOutsideClick('profile')"
              class="user-profile header-notification"
              [ngClass]="profileNotificationClass"
              (click)="toggleProfileNotification()"
            >
              <a href="javascript:">
                <img
                  *ngIf="currentUser.image"
                  [src]="currentUser.image"
                  class="user-profile-img"
                  alt="User-Profile-Image"
                />
                <img
                  *ngIf="!currentUser.image"
                  [src]="defaultUserImg"
                  class="user-profile-img"
                  alt="User-Profile-Image"
                />
                <span>{{ currentUser.username }}</span>
                <i class="ti-angle-down"></i>
              </a>
              <ul
                [@notificationBottom]="profileNotification"
                class="show-notification profile-notification"
              >
                <li>
                  <a [routerLink]="['/settings']">
                    <i class="ti-settings"></i> Settings
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/profile', currentUser.username]">
                    <i class="ti-user"></i> Profile
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/invites']">
                    <i class="ti-envelope"></i> Invites
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/welcome']">
                    <i class="ti-info-alt"></i> About uMuzi
                  </a>
                </li>
                <li>
                  <a (click)="logout()">
                    <i class="ti-layout-sidebar-left"></i> Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>

          <!-- Show this for logged out users -->
          <ul
            [@mobileHeaderNavRight]="navRight"
            [ngClass]="navRight"
            class="nav-right"
            *showAuthed="false"
          >
            <li>
              <a
                href="javascript:"
                routerLink="/login"
                routerLinkActive="active"
              >
                <i class="fa fa-sign-in"></i>
                <span class="ml-1">Sign-in</span>
              </a>
            </li>
            <li>
              <a
                href="javascript:"
                routerLink="/register"
                routerLinkActive="active"
              >
                <i class="fa fa-pencil-square-o"></i>
                <span class="ml-1">Register</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="pcoded-main-container" [style.margin-top]="headerFixedMargin">
      <nav
        id="main_navbar"
        class="pcoded-navbar"
        (clickOutside)="onClickedOutsideSidebar($event)"
        [exclude]="'#mobile-collapse'"
        [attr.pcoded-header-position]="pcodedHeaderPosition"
        [attr.navbar-theme]="navBarTheme"
        [attr.active-item-theme]="activeItemTheme"
        sub-item-theme="theme2"
        active-item-style="style0"
        [attr.pcoded-navbar-position]="pcodedSidebarPosition"
      >
        <div class="pcoded-inner-navbar" appAccordion>
          <span *ngFor="let asideItems of menuItems" class="d-color">
            <ul
              class="menu-main-item pcoded-item pcoded-left-item"
              [attr.item-border]="itemBorder"
              [attr.item-border-style]="itemBorderStyle"
              [attr.subitem-border]="subItemBorder"
              *ngFor="let asideItem of asideItems.main"
              appAccordionLink
              group="{{ asideItem.state }}"
            >
              <li
                [routerLinkActive]="['active']"
                *ngIf="asideItem.type === 'external'"
                appAccordionLink
                group="{{ asideItem.state }}"
              >
                <a
                  href="{{ asideItem.external }}"
                  target="{{ asideItem.target ? '_blank' : '_self' }}"
                  appAccordionToggle
                >
                  <span class="pcoded-micon">
                    <i class="{{ asideItem.icon }}"></i>
                    <b>{{ asideItem.short_label }}</b>
                  </span>
                  <span class="pcoded-mtext">{{ asideItem.name }}</span>
                  <span
                    *ngFor="let asideBadge of asideItem.badge"
                    class="pcoded-badge label label-{{ asideBadge.type }}"
                  >
                    {{ asideBadge.value }}
                  </span>
                  <span class="pcoded-mcaret"></span>
                </a>
              </li>
              <li
                [routerLinkActive]="['active']"
                *ngIf="asideItem.type === 'link'"
                appAccordionLink
                group="{{ asideItem.state }}"
              >
                <a
                  [routerLink]="['/', asideItem.main_state, asideItem.state]"
                  appAccordionToggle
                  *ngIf="!asideItem.target && asideItem.main_state"
                >
                  <span class="pcoded-micon">
                    <i class="{{ asideItem.icon }}"></i>
                    <b>{{ asideItem.short_label }}</b>
                  </span>
                  <span class="pcoded-mtext">{{ asideItem.name }}</span>
                  <span
                    *ngFor="let asideBadge of asideItem.badge"
                    class="pcoded-badge label label-{{ asideBadge.type }}"
                  >
                    {{ asideBadge.value }}
                  </span>
                  <span class="pcoded-mcaret"></span>
                </a>
                <a
                  [routerLink]="['/', asideItem.main_state, asideItem.state]"
                  target="_blank"
                  appAccordionToggle
                  *ngIf="asideItem.target && asideItem.main_state"
                >
                  <span class="pcoded-micon">
                    <i class="{{ asideItem.icon }}"></i>
                    <b>{{ asideItem.short_label }}</b>
                  </span>
                  <span class="pcoded-mtext">
                    {{ asideItem.name }}
                  </span>
                  <span
                    *ngFor="let asideBadge of asideItem.badge"
                    class="pcoded-badge label label-{{ asideBadge.type }}"
                  >
                    {{ asideBadge.value }}
                  </span>
                  <span class="pcoded-mcaret"></span>
                </a>
                <a
                  [routerLink]="['/', asideItem.state]"
                  *ngIf="!asideItem.target && !asideItem.main_state"
                  appAccordionToggle
                >
                  <span class="pcoded-micon">
                    <i class="{{ asideItem.icon }}"></i>
                    <b>{{ asideItem.short_label }}</b>
                  </span>
                  <span class="pcoded-mtext">{{ asideItem.name }}</span>
                  <span
                    *ngFor="let asideBadge of asideItem.badge"
                    class="pcoded-badge label label-{{ asideBadge.type }}"
                    >{{ asideBadge.value }}
                  </span>
                  <span class="pcoded-mcaret"></span>
                </a>
                <a
                  [routerLink]="['/', asideItem.state]"
                  *ngIf="asideItem.target && !asideItem.main_state"
                  target="_blank"
                  appAccordionToggle
                >
                  <span class="pcoded-micon">
                    <i class="{{ asideItem.icon }}"></i>
                    <b>{{ asideItem.short_label }}</b>
                  </span>
                  <span class="pcoded-mtext">
                    {{ asideItem.name }}
                  </span>
                  <span
                    *ngFor="let asideBadge of asideItem.badge"
                    class="pcoded-badge label label-{{ asideBadge.type }}"
                  >
                    {{ asideBadge.value }}
                  </span>
                  <span class="pcoded-mcaret"></span>
                </a>
              </li>
              <li
                [routerLinkActive]="['active']"
                *ngIf="asideItem.type === 'sub'"
                class="pcoded-hasmenu"
                [attr.dropdown-icon]="dropDownIcon"
                [attr.subitem-icon]="subItemIcon"
                appAccordionLink
                group="{{ asideItem.state }}"
              >
                <a
                  class="main-click-trigger"
                  [routerLinkActive]="['active']"
                  href="javascript:;"
                  appAccordionToggle
                >
                  <span class="pcoded-micon">
                    <i class="{{ asideItem.icon }}"></i>
                    <b>{{ asideItem.short_label }}</b>
                  </span>
                  <span class="pcoded-mtext">
                    {{ asideItem.name }}
                  </span>
                  <span
                    *ngFor="let asideBadge of asideItem.badge"
                    class="pcoded-badge label label-{{ asideBadge.type }}"
                  >
                    {{ asideBadge.value }}
                  </span>
                  <span class="pcoded-mcaret"></span>
                </a>
                <ul class="pcoded-submenu">
                  <ng-template
                    ngFor
                    let-asideChildren
                    [ngForOf]="asideItem.children"
                  >
                    <li
                      [routerLinkActive]="['active']"
                      *ngIf="asideChildren.type !== 'sub'"
                      appAccordionLink
                      group="{{ asideChildren.state }}"
                    >
                      <a
                        [routerLinkActive]="['active']"
                        href="{{ asideChildren.external }}"
                        target="{{ asideChildren.target ? '_blank' : '_self' }}"
                        *ngIf="
                          asideChildren.type === 'external';
                          else mainContentExternal
                        "
                      >
                        <div class="ripple menu-ripple"></div>
                        <span class="pcoded-micon">
                          <i class="icon-angle-right"></i>
                        </span>
                        <span class="pcoded-mtext">
                          {{ asideChildren.name }}
                        </span>
                        <span
                          *ngFor="let asideChildrenBadge of asideChildren.badge"
                          class="pcoded-badge label label-{{
                            asideChildrenBadge.type
                          }}"
                        >
                          {{ asideChildrenBadge.value }}
                        </span>
                        <span class="pcoded-mcaret"></span>
                      </a>
                      <ng-template #mainContentExternal>
                        <a
                          [routerLink]="[
                            '/',
                            asideChildren.main_state,
                            asideChildren.state
                          ]"
                          appAccordionToggle
                          *ngIf="
                            !asideChildren.target && asideChildren.main_state
                          "
                        >
                          <span class="pcoded-micon">
                            <i class="{{ asideChildren.icon }}"></i>
                            <b>{{ asideChildren.short_label }}</b>
                          </span>
                          <span class="pcoded-mtext">
                            {{ asideChildren.name }}
                          </span>
                          <span
                            *ngFor="let asideBadge of asideChildren.badge"
                            class="pcoded-badge label label-{{
                              asideBadge.type
                            }}"
                          >
                            {{ asideBadge.value }}
                          </span>
                          <span class="pcoded-mcaret"></span>
                        </a>
                        <a
                          [routerLink]="[
                            '/',
                            asideChildren.main_state,
                            asideChildren.state
                          ]"
                          target="_blank"
                          appAccordionToggle
                          *ngIf="
                            asideChildren.target && asideChildren.main_state
                          "
                        >
                          <span class="pcoded-micon">
                            <i class="{{ asideChildren.icon }}"></i>
                            <b>{{ asideChildren.short_label }}</b>
                          </span>
                          <span class="pcoded-mtext">
                            {{ asideChildren.name }}
                          </span>
                          <span
                            *ngFor="let asideBadge of asideChildren.badge"
                            class="pcoded-badge label label-{{
                              asideBadge.type
                            }}"
                          >
                            {{ asideBadge.value }}
                          </span>
                          <span class="pcoded-mcaret"></span>
                        </a>
                        <a
                          [routerLink]="['/', asideChildren.state]"
                          *ngIf="
                            !asideChildren.target && !asideChildren.main_state
                          "
                          appAccordionToggle
                        >
                          <span class="pcoded-micon">
                            <i class="{{ asideChildren.icon }}"></i>
                            <b>{{ asideChildren.short_label }}</b>
                          </span>
                          <span class="pcoded-mtext">
                            {{ asideChildren.name }}
                          </span>
                          <span
                            *ngFor="let asideBadge of asideChildren.badge"
                            class="pcoded-badge label label-{{
                              asideBadge.type
                            }}"
                          >
                            {{ asideBadge.value }}
                          </span>
                          <span class="pcoded-mcaret"></span>
                        </a>
                        <a
                          [routerLink]="['/', asideChildren.state]"
                          *ngIf="
                            asideChildren.target && !asideChildren.main_state
                          "
                          target="_blank"
                          appAccordionToggle
                        >
                          <span class="pcoded-micon">
                            <i class="{{ asideChildren.icon }}"></i>
                            <b>{{ asideChildren.short_label }}</b>
                          </span>
                          <span class="pcoded-mtext">
                            {{ asideChildren.name }}
                          </span>
                          <span
                            *ngFor="let asideBadge of asideChildren.badge"
                            class="pcoded-badge label label-{{
                              asideBadge.type
                            }}"
                          >
                            {{ asideBadge.value }}
                          </span>
                          <span class="pcoded-mcaret"></span>
                        </a>
                      </ng-template>
                    </li>

                    <li
                      [routerLinkActive]="['active']"
                      class="pcoded-hasmenu"
                      [attr.dropdown-icon]="dropDownIcon"
                      [attr.subitem-icon]="subItemIcon"
                      *ngIf="asideChildren.type === 'sub'"
                      appAccordionLink
                      group="sub-toggled"
                    >
                      <a href="javascript:;" appAccordionToggle>
                        <span class="pcoded-micon"
                          ><i class="ti-direction-alt"></i
                        ></span>
                        <span class="pcoded-mtext">
                          {{ asideChildren.name }}
                        </span>
                        <span
                          *ngFor="let asideChildrenBadge of asideChildren.badge"
                          class="pcoded-badge label label-{{
                            asideChildrenBadge.type
                          }}"
                        >
                          {{ asideChildrenBadge.value }}
                        </span>
                        <span class="pcoded-mcaret"></span>
                      </a>
                      <ul class="pcoded-submenu">
                        <ng-template
                          ngFor
                          let-asideChildrenSub
                          [ngForOf]="asideChildren.children"
                        >
                          <li
                            [routerLinkActive]="['active']"
                            *ngIf="asideChildrenSub.type !== 'sub'"
                            appAccordionLink
                          >
                            <a
                              [routerLink]="[
                                '/',
                                asideChildren.state,
                                asideChildrenSub.state
                              ]"
                              *ngIf="!asideChildrenSub.target"
                            >
                              <span class="pcoded-micon"
                                ><i class="ti-angle-right"></i
                              ></span>
                              <span class="pcoded-mtext">
                                {{ asideChildrenSub.name }}
                              </span>
                              <span
                                *ngFor="
                                  let asideChildrenSubBadge of asideChildrenSub.badge
                                "
                                class="pcoded-badge label label-{{
                                  asideChildrenSubBadge.type
                                }}"
                              >
                                {{ asideChildrenSubBadge.value }}
                              </span>
                              <span class="pcoded-mcaret"></span>
                            </a>
                            <a
                              [routerLink]="[
                                '/',
                                asideChildren.state,
                                asideChildrenSub.state
                              ]"
                              *ngIf="asideChildrenSub.target"
                              target="_blank"
                            >
                              <span class="pcoded-micon">
                                <i class="ti-angle-right"></i>
                              </span>
                              <span class="pcoded-mtext">
                                {{ asideChildrenSub.name }}
                              </span>
                              <span
                                *ngFor="
                                  let asideChildrenSubBadge of asideChildrenSub.badge
                                "
                                class="pcoded-badge label label-{{
                                  asideChildrenSubBadge.type
                                }}"
                              >
                                {{ asideChildrenSubBadge.value }}
                              </span>
                              <span class="pcoded-mcaret"></span>
                            </a>
                          </li>

                          <li
                            [routerLinkActive]="['active']"
                            class="pcoded-hasmenu"
                            [attr.dropdown-icon]="dropDownIcon"
                            [attr.subitem-icon]="subItemIcon"
                            *ngIf="asideChildrenSub.type === 'sub'"
                            appAccordionLink
                            group="sub-super-toggled"
                          >
                            <a href="javascript:;" appAccordionToggle>
                              <span class="pcoded-micon">
                                <i class="ti-direction-alt"></i>
                              </span>
                              <span class="pcoded-mtext">
                                {{ asideChildrenSub.name }}
                              </span>
                              <span
                                *ngFor="
                                  let asideChildrenSubBadge of asideChildrenSub.badge
                                "
                                class="pcoded-badge label label-{{
                                  asideChildrenSubBadge.type
                                }}"
                              >
                                {{ asideChildrenSubBadge.value }}
                              </span>
                              <span class="pcoded-mcaret"></span>
                            </a>
                            <ul class="pcoded-submenu">
                              <ng-template
                                ngFor
                                let-asideChildrenSubSuper
                                [ngForOf]="asideChildrenSub.children"
                              >
                                <li
                                  [routerLinkActive]="['active']"
                                  appAccordionLink
                                >
                                  <a
                                    [routerLinkActive]="['active']"
                                    href="{{ asideChildrenSubSuper.external }}"
                                    target="{{
                                      asideChildrenSubSuper.target
                                        ? '_blank'
                                        : '_self'
                                    }}"
                                    *ngIf="
                                      asideChildrenSubSuper.type === 'external';
                                      else mainContentExternalSub
                                    "
                                  >
                                    <div class="ripple menu-ripple"></div>
                                    <span class="pcoded-micon">
                                      <i class="icon-angle-right"></i>
                                    </span>
                                    <span class="pcoded-mtext">
                                      {{ asideChildrenSubSuper.name }}
                                    </span>
                                    <span
                                      *ngFor="
                                        let asideChildrenBadge of asideChildrenSubSuper.badge
                                      "
                                      class="pcoded-badge label label-{{
                                        asideChildrenBadge.type
                                      }}"
                                    >
                                      {{ asideChildrenBadge.value }}
                                    </span>
                                    <span class="pcoded-mcaret"></span>
                                  </a>
                                  <ng-template #mainContentExternalSub>
                                    <a
                                      [routerLink]="[
                                        '/',
                                        asideChildren.state,
                                        asideChildrenSub.state,
                                        asideChildrenSubSuper.state
                                      ]"
                                      *ngIf="!asideChildrenSubSuper.target"
                                    >
                                      <span class="pcoded-micon">
                                        <i class="ti-angle-right"></i>
                                      </span>
                                      <span class="pcoded-mtext">
                                        {{ asideChildrenSubSuper.name }}
                                      </span>
                                      <span
                                        *ngFor="
                                          let asideChildrenSubSuperBadge of asideChildrenSubSuper.badge
                                        "
                                        class="pcoded-badge label label-{{
                                          asideChildrenSubSuperBadge.type
                                        }}"
                                      >
                                        {{ asideChildrenSubSuperBadge.value }}
                                      </span>
                                      <span class="pcoded-mcaret"></span>
                                    </a>
                                    <a
                                      [routerLink]="[
                                        '/',
                                        asideChildren.state,
                                        asideChildrenSub.state,
                                        asideChildrenSubSuper.state
                                      ]"
                                      *ngIf="asideChildrenSubSuper.target"
                                      target="_blank"
                                    >
                                      <span class="pcoded-micon">
                                        <i class="ti-angle-right"></i>
                                      </span>
                                      <span class="pcoded-mtext">
                                        {{ asideChildrenSubSuper.name }}
                                      </span>
                                      <span
                                        *ngFor="
                                          let asideChildrenSubSuperBadge of asideChildrenSubSuper.badge
                                        "
                                        class="pcoded-badge label label-{{
                                          asideChildrenSubSuperBadge.type
                                        }}"
                                      >
                                        {{ asideChildrenSubSuperBadge.value }}
                                      </span>
                                      <span class="pcoded-mcaret"></span>
                                    </a>
                                  </ng-template>
                                </li>
                              </ng-template>
                            </ul>
                          </li>
                        </ng-template>
                      </ul>
                    </li>
                  </ng-template>
                </ul>
              </li>
            </ul>
          </span>
          <span class="d-color">
            <ul class="menu-main-item pcoded-item pcoded-left-item">
              <li>
                <a href="javascript:;">
                  <div class="ripple menu-ripple"></div>
                  <span class="pcoded-micon"
                    ><i class="ti-layout-list-post"></i
                  ></span>
                  <span class="pcoded-mtext"><strong>v2.0.1</strong></span>
                  <!--bindings={}-->
                  <span class="pcoded-mcaret"></span>
                </a>
              </li>
            </ul>
          </span>
        </div>
      </nav>
      <div class="pcoded-wrapper">
        <div class="pcoded-content">
          <div class="pcoded-inner-content">
            <!-- Main-body start -->
            <div class="main-body">
              <div class="page-wrapper">
                <router-outlet>
                  <app-title></app-title>
                  <app-breadcrumbs></app-breadcrumbs>
                  <app-spinner></app-spinner>
                </router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Loader spinner -->
<loader-animation
  class="col-12"
  [loading]="loading"
  [showMessage]="false"
  [message]="'Fetching analytics data'"
>
</loader-animation>
<!-- Loader spinner -->
